namespace GeniuzPOS.Common {
    export namespace CsiService {
        export const baseUrl = 'Csi';

        export declare function ImportPrTemplate(request: Common.Models.UploadFileRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ImportPoTemplate(request: Common.Models.UploadFileRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ImportBasicPromoTemplate(request: Common.Models.UploadFileRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ImportItemMasterTemplate(request: Common.Models.UploadFileRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ImportPriceChangeTemplate(request: Common.Models.UploadFileRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ImportAdjustStockTemplate(request: Common.Models.UploadFileRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ImportIcStockCountTemplate(request: Common.Models.UploadFileRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ImportIcStockReceiveDtTemplate(request: Common.Models.UploadFileRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ThaiReadCard(request: Common.Models.IDCardRequest, onSuccess?: (response: Common.Models.IDCardResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            ImportPrTemplate = "Csi/ImportPrTemplate",
            ImportPoTemplate = "Csi/ImportPoTemplate",
            ImportBasicPromoTemplate = "Csi/ImportBasicPromoTemplate",
            ImportItemMasterTemplate = "Csi/ImportItemMasterTemplate",
            ImportPriceChangeTemplate = "Csi/ImportPriceChangeTemplate",
            ImportAdjustStockTemplate = "Csi/ImportAdjustStockTemplate",
            ImportIcStockCountTemplate = "Csi/ImportIcStockCountTemplate",
            ImportIcStockReceiveDtTemplate = "Csi/ImportIcStockReceiveDtTemplate",
            ThaiReadCard = "Csi/ThaiReadCard"
        }

        [
            'ImportPrTemplate', 
            'ImportPoTemplate', 
            'ImportBasicPromoTemplate', 
            'ImportItemMasterTemplate', 
            'ImportPriceChangeTemplate', 
            'ImportAdjustStockTemplate', 
            'ImportIcStockCountTemplate', 
            'ImportIcStockReceiveDtTemplate', 
            'ThaiReadCard'
        ].forEach(x => {
            (<any>CsiService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
